module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectAtLeastOne":"Select at least one","status":"Status"},"fr":{"selectAtLeastOne":"Sélectionner au moins un","status":"Statut"}}')
  delete Component.options._Ctor
}
